export default {
    name: 'Name',
    tel: 'Tel',
    topic: 'Topic',
    description: 'Description',
    submit: 'Submit',
    mailSentSucceed: 'Message sent successfully',
    mailSentFailed: 'Failed to send message. Please try again'
}
